import { useParams } from '@exam-management/router';
import { TaskManagementPermissionRoute } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QSetReviewTaskLayout() {
  const { taskId } = useParams('/task-management/qset-review/:taskId');
  return (
    <TaskManagementPermissionRoute taskId={taskId}>
      <Outlet />
    </TaskManagementPermissionRoute>
  );
}
